import { useState } from 'react';
import { faqs } from '@/mocks/data';

export default function HomeFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            常见问题解答
          </h2>
          <p className="text-sm text-foreground-600">
            关于撸啊撸攻略和段位提升的最常见疑问
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-background-200/70 rounded-xl overflow-hidden bg-background-50"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-50/80 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="font-medium text-sm text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-colors ${openIndex === index ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'}`}>
                  <i className={`text-sm transition-transform duration-300 ${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}